import CreditNoteCrud from "../components/credit-note/CreditNoteCrud";

const CreditNotesPage = () => {
  return <CreditNoteCrud />;
};

export default CreditNotesPage;
